import ServicesTemplateLarge from './service-template-large';

export default ServicesTemplateLarge;